import { BiHttpTranslateLoader } from "@globals/classes/BiHttpTranslateLoader";
import { provideTranslateLoader, provideTranslateService, TranslateService } from "@ngx-translate/core";
import { BiTranslateService } from "./bi-translate.service";

/**
 * ***** Use this instead of "TranslateModule.forRoot"! ******
 * Providers copied from NGX Translate library's TranslateModule.forRoot method. We do NOT want to use
 * that method as we would then import the "TranslateModule" leading to duplicate translate pipes and directives
 * when we use BiTranslateDirective and BiTranslatePipe (and we should always use those!).
 */
export const biTranslateProviders = [
  provideTranslateService({
    loader: provideTranslateLoader(BiHttpTranslateLoader)
  }),
  { provide: TranslateService, useExisting: BiTranslateService }
];
